/**
 * @flow
 */

import Config from 'config';

export function gotoMyTickets() {
  window.location.href = `${Config.api.host}/dashboard/tickets`;
}

export function gotoCostItem(costItemId: string) {
  window.open(`${Config.api.host}/cost_items/${costItemId}.pdf`, '_blank');
}

export function gotoOrder(orderId: string) {
  window.location.href = `${Config.api.host}/dashboard/order/${orderId}`;
}

export function gotoTicket(ticketId: string) {
  window.location.href = `${Config.api.host}/dashboard/ticket/${ticketId}`;
}

export function gotoPaymentPlan(ticketId: string) {
  window.location.href = `${Config.api.host}/dashboard/payment-plans/${ticketId}`;
}

export function gotoTicketReceipt(ticketId: string) {
  window.open(`${Config.api.host}/tickets/${ticketId}.pdf`, '_blank');
}

export function gotoContactHost(hostId: string) {
  window.location.href = `${Config.api.host}/dashboard/conversations/withUser/${hostId}`;
}

export function gotoDownloadTicket(ticketId: string) {
  window.open(`${Config.api.host}/cost_items/${ticketId}.pdf`, '_blank');
}

export function gotoInvoice(invoiceId: string) {
  window.open(`${Config.api.host}/invoices/${invoiceId}.pdf`, '_blank');
}

export function gotoGenerateInvoice(ticketId: string) {
  window.location.href = `${Config.api.host}/dashboard/invoice/${ticketId}`;
}

export function gotoDashboardPage() {
  window.location.href = `${Config.api.host}/dashboard`;
}

export function gotoReportsPage() {
  window.location.href = `${Config.api.host}/dashboard/reports`;
}

export function gotoCreateNewReport() {
  window.location.href = `${Config.api.host}/beta/dashboard/reports/create`;
}

export function gotoEditReport(reportId: string) {
  window.location.href = `${Config.api.host}/beta/dashboard/reports/edit/${reportId}`;
}



// WEBPACK FOOTER //
// ./src/lib/navigate-to.js